// 浏览器兼容性polyfill - 完整版本
// 支持旧版浏览器的现代JavaScript功能

// 立即执行的polyfill函数 - 确保在应用代码之前执行
(function() {
  'use strict'
  
  console.log('🚀 开始加载浏览器兼容性polyfill...')
  
  // 1. Object.assign polyfill
  if (typeof Object.assign !== 'function') {
    console.log('📦 加载Object.assign polyfill...')
    Object.assign = function(target) {
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object')
      }
      
      var to = Object(target)
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index]
        if (nextSource != null) {
          for (var nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey]
            }
          }
        }
      }
      return to
    }
    console.log('✅ Object.assign polyfill加载成功')
  } else {
    console.log('✅ Object.assign已原生支持')
  }
  
  // 2. Array.prototype.includes polyfill
  if (!Array.prototype.includes) {
    console.log('📦 加载Array.prototype.includes polyfill...')
    Object.defineProperty(Array.prototype, 'includes', {
      value: function(searchElement, fromIndex) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined')
        }

        var o = Object(this)
        var len = o.length >>> 0

        if (len === 0) {
          return false
        }

        var n = fromIndex | 0
        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)

        while (k < len) {
          if (o[k] === searchElement) {
            return true
          }
          k++
        }

        return false
      }
    })
    console.log('✅ Array.prototype.includes polyfill加载成功')
  } else {
    console.log('✅ Array.prototype.includes已原生支持')
  }
  
  // 3. String.prototype.includes polyfill
  if (!String.prototype.includes) {
    console.log('📦 加载String.prototype.includes polyfill...')
    String.prototype.includes = function(search, start) {
      'use strict'
      if (typeof start !== 'number') {
        start = 0
      }
      
      if (start + search.length > this.length) {
        return false
      } else {
        return this.indexOf(search, start) !== -1
      }
    }
    console.log('✅ String.prototype.includes polyfill加载成功')
  } else {
    console.log('✅ String.prototype.includes已原生支持')
  }
  
  // 4. Promise polyfill (基础版本)
  if (typeof Promise === 'undefined') {
    console.log('📦 加载Promise polyfill...')
    window.Promise = function(executor) {
      console.warn('⚠️ Promise polyfill已加载，但功能有限。建议使用现代浏览器。')
      // 简化的Promise实现
      var self = this
      self.status = 'pending'
      self.value = undefined
      self.reason = undefined
      
      function resolve(value) {
        if (self.status === 'pending') {
          self.status = 'fulfilled'
          self.value = value
        }
      }
      
      function reject(reason) {
        if (self.status === 'pending') {
          self.status = 'rejected'
          self.reason = reason
        }
      }
      
      try {
        executor(resolve, reject)
      } catch (e) {
        reject(e)
      }
    }
    console.log('✅ Promise polyfill加载成功')
  } else {
    console.log('✅ Promise已原生支持')
  }
  
  console.log('🎉 所有polyfill加载完成!')
  
})()

// 页面加载完成后检查polyfill状态
window.addEventListener('DOMContentLoaded', function() {
  console.log('📋 检查浏览器兼容性状态...')
  
  var missingFeatures = []
  
  // 检查关键功能
  if (typeof Object.assign !== 'function') {
    missingFeatures.push('Object.assign')
  }
  
  if (!Array.prototype.includes) {
    missingFeatures.push('Array.prototype.includes')
  }
  
  if (!String.prototype.includes) {
    missingFeatures.push('String.prototype.includes')
  }
  
  if (missingFeatures.length > 0) {
    console.error('❌ 以下功能仍缺失:', missingFeatures.join(', '))
    
    // 显示用户友好的错误信息
    var errorDiv = document.createElement('div')
    errorDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background: linear-gradient(135deg, #ff6b6b, #ee5a24);
      color: white;
      padding: 20px;
      text-align: center;
      z-index: 10000;
      font-family: Arial, sans-serif;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      border-bottom: 2px solid #c23616;
    `
    errorDiv.innerHTML = `
      <h3 style="margin: 0 0 10px 0; font-size: 18px;">🚨 浏览器兼容性问题</h3>
      <p style="margin: 5px 0; font-size: 14px;">您的浏览器缺少以下功能: <strong>${missingFeatures.join(', ')}</strong></p>
      <p style="margin: 5px 0; font-size: 14px;">请使用现代浏览器如 Chrome、Firefox、Safari 或 Edge</p>
      <p style="margin: 5px 0; font-size: 12px; opacity: 0.8;">技术支持: 刷新页面或清除浏览器缓存后重试</p>
    `
    
    // 确保body元素存在后再添加错误提示
    if (document.body) {
      document.body.appendChild(errorDiv)
    } else {
      // 如果body还不存在，等待DOM加载完成
      document.addEventListener('DOMContentLoaded', function() {
        document.body.appendChild(errorDiv)
      })
    }
    
  } else {
    console.log('✅ 所有浏览器兼容性功能正常!')
    
    // 显示成功提示（可选）
    var successDiv = document.createElement('div')
    successDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background: linear-gradient(135deg, #4cd137, #44bd32);
      color: white;
      padding: 10px;
      text-align: center;
      z-index: 10000;
      font-family: Arial, sans-serif;
      font-size: 12px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    `
    successDiv.innerHTML = '✅ 浏览器兼容性检查通过 - 应用正常运行中...'
    
    if (document.body) {
      document.body.appendChild(successDiv)
      // 3秒后自动隐藏
      setTimeout(function() {
        successDiv.style.transition = 'opacity 0.5s'
        successDiv.style.opacity = '0'
        setTimeout(function() {
          if (successDiv.parentNode) {
            successDiv.parentNode.removeChild(successDiv)
          }
        }, 500)
      }, 3000)
    }
  }
})

console.log('🌐 浏览器兼容性polyfill模块加载完成')